<div class="flex flex-column gap pb-3">
    @if (store.isSocial()) {
        <app-service-setting-service-group
            [groupType]="ServiceGroupEnum.SOCIAL_TARGET"
        ></app-service-setting-service-group>
    }

    <app-service-setting-service-group
        [groupType]="ServiceGroupEnum.GENERAL"
    ></app-service-setting-service-group>

    @if (store.isSocial()) {
        <app-service-setting-service-group
            [groupType]="ServiceGroupEnum.OFFERS"
        ></app-service-setting-service-group>
    }
    @if (store.creditsEnabled()) {
        <app-service-setting-service-group [groupType]="ServiceGroupEnum.CREDITS" />
    }
</div>
